import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import * as Icons from './icons/Icons';

export default class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.cancelButtonClick = this.cancelButtonClick.bind(this);
        this.okButtonClick = this.okButtonClick.bind(this);
    }

    getCancelButton() {
        if (!this.props.cancelButton) {
            return (
                <button
                onClick={this.cancelButtonClick}
                    className="rec-button-tertiary"
                    title={this.props.cancelButtonLabel}
                    aria-label={this.props.cancelButtonLabel}>
                    {this.props.cancelButtonLabel}
                </button>
            );
        }
        return this.props.cancelButton;
    }

    getOkButton() {
        if (!this.props.okButton) {
            return (<button
                className="rec-button-primary"
                title={this.props.okButtonLabel}
                onClick={this.okButtonClick}
                aria-label={this.props.okButtonLabel}>
                {this.props.okButtonLabel}
                    </button>);
        }
        return this.props.okButton;
    }

    openModal() {
        return new Promise((resolve) => {
            this.setState({ modalIsOpen: true });
            this.openModalPromiseCallBack = (result) => resolve(result);
        });
    }

    okButtonClick() {
        this.setState({ modalIsOpen: false });
        this.closeModal(this.props.okButtonLabel);
    }

    cancelButtonClick() {
        this.setState({ modalIsOpen: false });
        this.closeModal(this.props.cancelButtonLabel);
    }

    closeModal(result) {
        this.openModalPromiseCallBack(result);
    }

    render() {
        return (
            <Modal
                ariaHideApp={false}
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.props.afterOpenModal}
                onRequestClose={this.cancelButtonClick}
                role="complementary"
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                {...this.props}>
                <div className="rec-modal-content-wrap ">
                    <button
                        className="rec-close-modal"
                        onClick={this.cancelButtonClick}>
                        <Icons.IconClose />
                    </button>
                    <div className="rec-modal-title">{this.props.modalHeader}</div>
                    {this.props.children}
                </div>
                <div className="rec-modal-actions-wrap">
                    {this.getCancelButton()}
                    {this.getOkButton()}
                </div>
            </Modal>
        );
    }
}


ModalDialog.propTypes = {
    children: PropTypes.node.isRequired,
    modalHeader: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    cancelButton: PropTypes.node,
    afterOpenModal: PropTypes.func,
    okButton: PropTypes.node,
    okButtonLabel: PropTypes.string,
    cancelButtonLabel: PropTypes.string
};

ModalDialog.defaultProps = {
    children: null,
    modalHeader: "Information",
    cancelButton: null,
    okButton: null,
    afterOpenModal() {},
    okButtonLabel: 'Ok',
    cancelButtonLabel: 'Cancel'
};
